import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Icon from '../icon';

const MenuItem = (props) => {
	const {
		active,
		isActive,
		className,
		href,
		icon,
		svg,
		label,
		set,
		rightElement,
		onClick,
		...sendProps
	} = props;
	
	let _active = false;
	if (isActive) _active = isActive(props);
	if (active) _active = active;

	sendProps.className = (className || '') + (_active ? ' active' : '');
	
	const onClickInner = e => {
		// console.log('IconLink:', href, onClick);
		if (!href) e.preventDefault();
		if (onClick) onClick(e);
	};
	
	return href ? <Link to={href} {...sendProps} onClick={e => onClickInner(e)}>
			{icon && <Icon icon={icon} set={set} className={label ? '' : 'no-label'} />}
			{svg}
			{icon || svg ? <span className="text">{label}</span> : label}
			{rightElement && <span className="right-element">{rightElement}</span>}
		</Link>
		:
		<a href="#" {...sendProps} onClick={e => onClickInner(e)}>
			{icon && <Icon icon={icon} set={set} className={label ? '' : 'no-label'} />}
			{svg}
			{icon || svg ? <span className="text">{label}</span> : label}
			{rightElement && <span className="right-element">{rightElement}</span>}
		</a>;
};

MenuItem.propTypes = {
	href: PropTypes.string,
	icon: PropTypes.string,
	svg: PropTypes.any,
	className: PropTypes.string,
	rightElement: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
	]),
	label: PropTypes.any.isRequired,
	onClick: PropTypes.func,
	isActive: PropTypes.func,
	active: PropTypes.bool,
};

export default MenuItem;
